"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateUserInfoType = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../constants");
class PrivateUserInfoType {
    constructor(userId, firstName, lastName) {
        this.userId = userId;
        this.firstName = firstName;
        this.lastName = lastName;
    }
    static collectionPath(userId) {
        return `${constants_1.constants.COLLECTION_PATH_USER}/${userId}/${constants_1.constants.COLLECTION_PATH_PRIVATE_INFO}`;
    }
    isEqual(other) {
        return this.userId === other.userId &&
            this.firstName === other.firstName &&
            this.lastName === other.lastName &&
            this.timeZone === other.timeZone &&
            this.stripeCustomerId === other.stripeCustomerId;
    }
}
exports.PrivateUserInfoType = PrivateUserInfoType;
